module.exports = __webpack_public_path__ + "media/images/flags/hk-16b893ced54cfd9e5116af3a950c75a6.svg";